import { useEffect, useState } from "react";
import swal from 'sweetalert2';
import { blockTeeTime, getTeeTimeBook, getTeeTimeInit } from "../api/teeTimeAPI";

const getStatusMeta = (m) => {
    if (m.Status === "Pending") {
        return { label: "Pending", className: "slot-card-status--pending", icon: "fa-clock-o" };
    }
    if (m.Status === "Booked") {
        return { label: "Booked", className: "slot-card-status--booked", icon: "fa-times-circle" };
    }
    if (m.Status === "Remaining") {
        return { label: m.DisplayStatus, className: "slot-card-status--limited", icon: "fa-check-circle" };
    }
    if (m.Status === "Available" || m.Status === null) {
        return { label: "Available", className: "slot-card-status--available", icon: "fa-check-circle" };
    }
    return { label: "Not Available", className: "slot-card-status--booked", icon: "fa-times-circle" };
};

const slot = (props) => {
    const [teeTimeBook, setTeeTimeBook] = useState([]);
    const [loading, setLoading] = useState(true);
    const [refresh, setRefresh] = useState(false);

    useEffect(() => {
        $('#modalSlot').modal({ backdrop: 'static', keyboard: false });
        $(props.from).addClass('modal-blur');
        $('#modalSlot').on('hidden.bs.modal', function () {
            $('.modal').hasClass('show') && $('body').addClass('modal-open');
            props.onDismissModal(false);
        });
    }, [])



    useEffect(() => {
        if (props.date) fetchTeeSlot()
    }, [refresh]);

    const refetchTeeTime = () => setRefresh((r) => !r);
    useEffect(() => {
        if (!!props?.socketMaster) {
            props.socketMaster.on('refresh-teesheet', (res) => {
                const { data } = res;

                if (data) {
                    if (data.Action == 'Refresh') return refetchTeeTime();

                    // This modal only ever shows TeeTimeBook slots -- ignore Shotgun payloads
                    // rather than calling a setter that doesn't exist here.
                    if (data.Type === 'Slot' && data?.TeeTimeBook?.length > 0) {
                        setTeeTimeBook(data.TeeTimeBook);
                    }
                }
            });
        }
    }, [props]);

    const fetchTeeSlot = async () => {
        setLoading(true);
        try {
            const tee = await getTeeTimeBook(props.date)
            setTeeTimeBook(tee.TeeTimeBook || [])
        } finally {
            setLoading(false);
        }
    }

    const handleSlot = async (book, Captcha = false) => {

        if (props.from === "header") return;
        try {
            // if (props.oldSlot.TemplateID == book.TemplateID) {
            //     swal.close();
            //     $('#modalSlot').modal('hide');
            //     onClose()
            //     return swal.fire({ icon: 'error', timer: 1500, showConfirmButton: false, titleText: `Can't Book Same Slot` });
            // }
            if (book.Status === "Booked" || book.Status === "Pending") {
                swal.close();
                $('#modalSlot').modal('hide');
                onClose()
                return swal.fire({ icon: 'error', timer: 1500, showConfirmButton: false, titleText: `Slot Already Occupied` });
            }
            if ((4 - Number(book.UserCount)) < Number(props.totalMembersCount)) {
                swal.close();
                $('#modalSlot').modal('hide');
                onClose()
                return swal.fire({ icon: 'error', timer: 1500, showConfirmButton: false, titleText: 'No Available Slot' });
            }
            if (book.Status == "Available" || book.Status === "Remaining" || book.Status == null) {
                props.setSlot({
                    Slot: book.Slot,
                    TemplateID: book.TemplateID
                })

                setTimeout(() => {
                    if (typeof $ !== "undefined") {
                        $("#modalSlot").modal("hide");
                        if (props.from) {
                            $(props.from).removeClass("modal-blur");
                        }
                    }
                }, 50);
            } else {
                swal.close();
                $('#modalSlot').modal('hide');
                onClose()
                return swal.fire({ icon: 'error', timer: 1500, showConfirmButton: false, titleText: `Slot Not Available` });
            }
        } catch (error) {
            console.error("Error adding player:", error);
        }
    };

    const onClose = () => $(props.from).removeClass('modal-blur');

    const renderSlotCard = (m) => {
        const status = getStatusMeta(m);
        const isSelected = m.TemplateID == props.slot?.TemplateID;
        const isDisabled = m.Status === "Booked";

        return (
            <div className="col-xs-6 col-md-6 col-lg-3 padding-0" key={m.TemplateID}>
                <div
                    className={`slot-card ${isSelected ? 'slot-card-selected' : ''} ${isDisabled ? 'disableClick' : ''}`}
                    onClick={() => handleSlot(m)}
                >
                    {isSelected && (
                        <span className="slot-card-selected-check">
                            <i className="fa fa-check" aria-hidden="true"></i>
                        </span>
                    )}
                    {m.DiscountLabel && (
                        <span className="slot-card-discount-badge" title="Dynamic Pricing discount available for this slot">
                            {/* <i className="fa fa-tag" aria-hidden="true"></i> */}
                            {m.DiscountLabel}
                        </span>
                    )}
                    <div className="slot-card-time">{m.Slot}</div>
                    <div className={`slot-card-status ${status.className}`}>
                        <i className={`fa ${status.icon}`} aria-hidden="true"></i>
                        <strong>{status.label}</strong>
                    </div>
                </div>
            </div>
        );
    };

    const renderTeeBoxSection = (label, teeBox) => {
        const slots = teeTimeBook.filter(f => f.TeeBox == teeBox);

        return (
            <div className="col-xs-12 col-md-5">
                <div className="slot-section-header">
                    <i className="fa fa-flag-o" aria-hidden="true"></i>
                    <span>{label}</span>
                </div>
                <div className="row">
                    {slots.length > 0
                        ? slots.map(renderSlotCard)
                        : <div className="slot-empty-state">No slots available</div>}
                </div>
            </div>
        );
    };

    return (<>
        <div id="modalSlot" className="modal fade modal-responsive" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header padding-b0">
                        <button type="button" className="close" data-dismiss="modal"> <span aria-hidden="true" onClick={onClose}> &times; </span> </button>
                        <h5 className="modal-title" id="member-modal-title">Select Tee Time</h5>
                        {props.date && (
                            <p className="slot-modal-subtitle">
                                {moment(props.date, 'YYYY-MM-DD').format('dddd, DD MMM YYYY')}
                            </p>
                        )}
                    </div>

                    <div className="slot-legend">
                        <span className="slot-legend-item"><i className="slot-legend-dot slot-legend-dot--available"></i> Available</span>
                        <span className="slot-legend-item"><i className="slot-legend-dot slot-legend-dot--limited"></i> Limited</span>
                        <span className="slot-legend-item"><i className="slot-legend-dot slot-legend-dot--booked"></i> Booked</span>
                        <span className="slot-legend-item"><i className="fa fa-tag slot-legend-tag" aria-hidden="true"></i> Dynamic Pricing deal</span>
                    </div>

                    <div className="modal-body overflow-x padding-30 margin-20">
                        {loading ? (
                            <div className="slot-loading">
                                <span className="slot-loading-spinner"></span>
                                <span>Loading tee times...</span>
                            </div>
                        ) : (
                            <div className="row">
                                {renderTeeBoxSection("1st Tee", 1)}
                                <div className="hidden-xs hidden-sm col-md-2"></div>
                                {renderTeeBoxSection("10th Tee", 10)}
                            </div>
                        )}
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn btn-default" data-dismiss="modal" onClick={onClose}> Close </button>
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default slot;
